module.exports = __webpack_public_path__ + "img/logo4.03b2f82f.png";